(() => {
  const oldPickerSelector = '[id*=\"color-navigation\"], [class*=\"color-navigation\"], .mk-linked-colors, .mk-ss-family-picker';
  const customPickerSelector = '.mk-real-ss-picker-mounted';

  const clean = () => {
    if (!document.querySelector(customPickerSelector)) return;

    document.querySelectorAll(oldPickerSelector).forEach((node) => {
      if (node.matches(customPickerSelector) || node.closest(customPickerSelector)) return;
      node.remove();
    });

    document.querySelectorAll(`${customPickerSelector} [class*=\"variants-btn-\"], ${customPickerSelector} .swiper-button-prev, ${customPickerSelector} .swiper-button-next, ${customPickerSelector} .swiper-pagination`).forEach((node) => node.remove());
  };

  document.addEventListener('DOMContentLoaded', clean);
  document.addEventListener('shopify:section:load', clean);
  [150, 500, 1000, 2000, 3500, 5000].forEach((delay) => window.setTimeout(clean, delay));

  const observer = new MutationObserver(clean);
  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
